exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__SplitViewHeader__header__1CVRU {\n  background-color: #f9f9f9;\n  -webkit-box-shadow: 0 0 4px 0 rgb(0 0 0 / 30%);\n          box-shadow: 0 0 4px 0 rgb(0 0 0 / 30%);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-weight: 500;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 16px;\n  position: relative;\n  z-index: 10;\n}\n\n.dmb-web__SplitViewHeader__header__1CVRU h3 {\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0;\n}\n\n.dmb-web__SplitViewHeader__header__1CVRU div, .dmb-web__SplitViewHeader__header__1CVRU time {\n  font-weight: normal;\n}\n", ""]);

// exports
exports.locals = {
	"header": "dmb-web__SplitViewHeader__header__1CVRU"
};